"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.min = exports.max = exports.sum = exports.toNum = exports.formatNumber = void 0;
function formatNumber(n) {
    if (Math.abs(n) >= 1000000)
        return `${toNum(n / 1000000)}MM`;
    if (Math.abs(n) >= 1000)
        return `${toNum(n / 1000)}K`;
    return toNum(n);
}
exports.formatNumber = formatNumber;
function toNum(num) {
    return num.toLocaleString(undefined, { maximumFractionDigits: 2 });
}
exports.toNum = toNum;
function sum(nums) {
    if (!Array.isArray(nums) || !nums.length)
        return 0;
    return nums.reduce((acc, num) => {
        if (isNaN(num))
            return acc;
        return acc + num;
    }, 0);
}
exports.sum = sum;
function max(nums) {
    if (!Array.isArray(nums) || !nums.length)
        return undefined;
    return nums.reduce((acc, c) => acc > c ? acc : c);
}
exports.max = max;
function min(nums) {
    if (!Array.isArray(nums) || !nums.length)
        return undefined;
    return nums.reduce((acc, c) => acc < c ? acc : c);
}
exports.min = min;
//# sourceMappingURL=number.js.map